import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle, useFeatures } from '@cordata/buffet';
import { first, last } from 'lodash';

import { UncontrolledTable } from '~/components/common';

import { useAdmin } from '~/utils/admin';

const defaultSorted = [{
  id: 'departmentLabel',
}];

const COLUMNS = [{
  id: 'departmentLabel',
  Header: 'Name',
  accessor: 'attributes.departmentLabel',
}, {
  id: 'divisionName',
  Header: 'Division',
  accessor: 'attributes.divisionName',
}];

const orgColumn = {
  id: 'orgName',
  Header: 'Organization',
  accessor: 'attributes.orgName',
};

const DepartmentsIndex = () => {
  const { hasAppKickstarter } = useFeatures();
  const history = useHistory();
  const [columns, setColumns] = useState(COLUMNS);
  const { org, div } = useAdmin();

  useEffect(() => {
    if (hasAppKickstarter) {
      setColumns([first(COLUMNS), orgColumn, last(COLUMNS)]);
    } else {
      setColumns(COLUMNS);
    }
  }, [hasAppKickstarter]);

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/admin/departments/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Department</span>
          </Button>
        }
      >
        Departments
      </PageTitle>

      {org && div &&
        <UncontrolledTable
          name="departments"
          defaultSorted={defaultSorted}
          endpoint={{
            url: 'admin/department',
            params: {
              'org-uid': org.id,
              'division-uid': div.id,
            },
          }}
          columns={columns}
          getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/departments/${rowInfo.original.id}`)),
          })}
        />
      }
    </>
  );
};

export default DepartmentsIndex;
